import { render, staticRenderFns } from "./SelfServiceMyIdentifyInfo.vue?vue&type=template&id=434a2be2&scoped=true"
import script from "./SelfServiceMyIdentifyInfo.vue?vue&type=script&lang=js"
export * from "./SelfServiceMyIdentifyInfo.vue?vue&type=script&lang=js"
import style0 from "./SelfServiceMyIdentifyInfo.vue?vue&type=style&index=0&id=434a2be2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434a2be2",
  null
  
)

export default component.exports